import {
  GET_BATCH_FORMS_REQUEST,
  GET_BATCH_FORMS_SUCCESS,
  GET_BATCH_FORMS_FAILURE,
  SEARCH_BATCH_FORMS_REQUEST,
  SEARCH_BATCH_FORMS_SUCCESS,
  SEARCH_BATCH_FORMS_FAILURE
} from 'actions';

/**
 * The batchForms reducer
 */
function batchForms(state = {
  isGettingBatchForms: false,
  batchForms: [],
  batchFormsCount: 0,
  filteredValues: []
}, action) {
  switch (action.type) {
    case GET_BATCH_FORMS_REQUEST:
      return {
        ...state,
        isGettingBatchForms: action.isGettingBatchForms
      };
    case GET_BATCH_FORMS_SUCCESS:
      return {
        ...state,
        isGettingBatchForms: action.isGettingBatchForms,
        batchItem: action.batchItem,
        batchFileItem: action.batchFileItem,
        batchForms: action.batchForms,
        batchFormsCount: action.batchFormsCount
      };
    case GET_BATCH_FORMS_FAILURE:
      return {
        ...state,
        isGettingBatchForms: action.isGettingBatchForms,
        getBatchFormsError: action.getBatchFormsError
      };
    case SEARCH_BATCH_FORMS_REQUEST:
      return {
        ...state,
        isGettingBatchForms: action.isGettingBatchForms
      };
    case SEARCH_BATCH_FORMS_SUCCESS:
      return {
        ...state,
        isGettingBatchForms: action.isGettingBatchForms,
        batchForms: action.batchForms,
        batchFormsCount: action.batchFormsCount
      };
    case SEARCH_BATCH_FORMS_FAILURE:
      return {
        ...state,
        isGettingBatchForms: action.isGettingBatchForms,
        getBatchFormsError: action.getBatchFormsError
      };
    default:
      return state;
  }
}

export default batchForms;
